export const updateTitleOnVisibilityChange = () => {
  const originalTitle = document.title;
  let timeoutId: ReturnType<typeof setTimeout>;

  function animateTitle() {
    document.title = originalTitle;
    timeoutId = setTimeout(() => {
      document.title = "Bundle & save 🎉";
      timeoutId = setTimeout(animateTitle, 1000);
    }, 4000);
  }

  function clearTitleAnimation() {
    clearTimeout(timeoutId);
    document.title = originalTitle;
  }

  document.addEventListener("visibilitychange", () => {
    if (document.hidden) {
      animateTitle();
    } else {
      clearTitleAnimation();
    }
  });
};
